import * as React from 'react';
import { EntityType } from '@shapeable/types';

export const EntityTypeContext = React.createContext<EntityType[]>([]);
export const EntityTypeProvider = EntityTypeContext.Provider;